export default __webpack_public_path__ + "static/media/Accounts.d898e320.svg";